import { render, staticRenderFns } from "./ImsUserTableMenu.vue?vue&type=template&id=184c4b78&scoped=true&"
import script from "./ImsUserTableMenu.vue?vue&type=script&lang=js&"
export * from "./ImsUserTableMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "184c4b78",
  null
  
)

export default component.exports